export function MuseArrowRight() {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M6.39205 10.6023L5.36932 9.59089L8.92045 6.03976H0V4.56248H8.92045L5.36932 1.01703L6.39205 -1.71661e-05L11.6932 5.30112L6.39205 10.6023Z"
        fill="#3643BA"
      />
    </svg>
  )
}
